







import Vue from 'vue';
import '@bfe/mtd-theme-220/index.css';
import '@mt-material/pm-components/lib/theme-chalk/index.css';
import PMComponents from '@mt-material/pm-components';
Vue.use(PMComponents);

export default Vue.extend({
    name: 'App'
});
